/* QUIET — couche premium (refonte 29-09)
   Animations au défilement, en-tête, panier coulissant, ajout au panier sans
   rechargement, quiz, comparateur, scènes d'usage, date de livraison estimée. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('q-js');
  window.__qReady = true;
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- En-tête compact au défilement ---------- */
  var pageWrap = document.querySelector('.page-wrapper');
  function currentScroll() {
    return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, pageWrap ? pageWrap.scrollTop : 0);
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('q-scrolled', currentScroll() > 12);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (pageWrap) pageWrap.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Hauteur du bandeau d'annonce : il défile, l'en-tête reste collé en haut */
  function setTopbar() {
    var tb = document.querySelector('.lp-topbar');
    root.style.setProperty('--q-topbar-h', (tb ? tb.offsetHeight : 0) + 'px');
  }
  setTopbar();
  window.addEventListener('resize', setTopbar);

  /* ---------- Apparitions au défilement ---------- */
  var autoReveal = [
    '.lp-section-head', '.lp-step', '.lp-g-item', '.lp-faq-item', '.lp-final-cta',
    '.lp-newsletter', '.q-card', '.q-tile', '.lp-trust-band .lp-stat', '.q-compare', '.q-helpcard'
  ];
  autoReveal.forEach(function (sel) {
    $$(sel).forEach(function (el, i) {
      if (el.hasAttribute('data-reveal') || el.closest('.q-drawer')) return;
      el.setAttribute('data-reveal', '');
      var parent = el.parentElement;
      if (parent) {
        var idx = Array.prototype.indexOf.call(parent.children, el) % 4;
        if (idx) el.setAttribute('data-reveal-delay', String(idx));
      }
    });
  });

  function revealAll() { $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); }); }
  if (!('IntersectionObserver' in window) || reduceMotion) {
    revealAll();
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.01 });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  }

  /* Barres (dB, bruit) qui se remplissent quand elles entrent à l'écran */
  function fillBars(ctx) {
    $$('[data-w]', ctx).forEach(function (bar) { bar.style.width = bar.getAttribute('data-w') + '%'; });
  }
  if ('IntersectionObserver' in window) {
    var barIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { fillBars(entry.target); barIO.unobserve(entry.target); }
      });
    }, { threshold: 0.25 });
    $$('[data-q-bars]').forEach(function (el) { barIO.observe(el); });
  } else {
    fillBars(document);
  }

  /* ---------- Hero : image qui se pose + indicateur de bruit ---------- */
  var hero = $('.q-hero');
  if (hero) requestAnimationFrame(function () { hero.classList.add('is-ready'); });

  $$('[data-q-meter]').forEach(function (meter) {
    var states;
    try { states = JSON.parse(meter.getAttribute('data-q-meter')); } catch (e) { return; }
    if (!states || !states.length) return;
    var valEl = $('.q-meter__val', meter);
    var labelEl = $('.q-meter__label', meter);
    var barsWrap = $('.q-meter__bars', meter);
    var bars = [];
    for (var i = 0; i < 18; i++) { var b = document.createElement('i'); barsWrap.appendChild(b); bars.push(b); }
    var idx = 0;
    function show() {
      var s = states[idx];
      valEl.textContent = s.db + ' dB';
      labelEl.textContent = s.label;
      var level = Math.max(0.12, Math.min(1, (s.db - 20) / 70));
      bars.forEach(function (bar, j) {
        var wave = 0.55 + 0.45 * Math.abs(Math.sin(j * 0.9 + idx * 1.7));
        bar.style.height = Math.round(12 + 88 * level * wave) + '%';
        bar.style.background = s.quiet ? 'var(--q-forest)' : 'var(--q-amber-2)';
      });
      idx = (idx + 1) % states.length;
    }
    show();
    if (!reduceMotion) setInterval(show, 2600);
  });

  /* ---------- Onglets « Usages » ---------- */
  $$('[data-q-tabs]').forEach(function (wrap) {
    var tabs = $$('[data-q-tab]', wrap);
    var panels = $$('[data-q-scene]', wrap);
    function activate(i) {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.tabIndex = j === i ? 0 : -1;
      });
      panels.forEach(function (p, j) {
        var on = j === i;
        p.classList.toggle('is-active', on);
        p.hidden = !on;
        if (on) {
          $$('[data-w]', p).forEach(function (bar) { bar.style.width = '0'; });
          requestAnimationFrame(function () { requestAnimationFrame(function () { fillBars(p); }); });
        }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          activate(n); tabs[n].focus();
        }
      });
    });
    activate(0);
  });

  /* ---------- Comparateur : colonne survolée ---------- */
  $$('[data-q-compare]').forEach(function (table) {
    table.addEventListener('mouseover', function (e) {
      var cell = e.target.closest('[data-col]');
      $$('.is-col-hover', table).forEach(function (c) { c.classList.remove('is-col-hover'); });
      if (!cell) return;
      $$('[data-col="' + cell.getAttribute('data-col') + '"]', table).forEach(function (c) { c.classList.add('is-col-hover'); });
    });
    table.addEventListener('mouseleave', function () {
      $$('.is-col-hover', table).forEach(function (c) { c.classList.remove('is-col-hover'); });
    });
  });

  /* ---------- Date de livraison estimée ----------
     Délais réels du fournisseur (02-10) : commande passée un vendredi 2 → reçue entre le 7 et le 10,
     soit 5 à 8 jours calendaires (expédition sous 24/48 h comprise). Pour ajuster : data-min / data-max
     sur l'élément, ou les valeurs par défaut ci-dessous. */
  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }
  function etaText(minDays, maxDays) {
    try {
      var now = new Date();
      var a = addDays(now, minDays);
      var b = addDays(now, maxDays);
      var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
      return 'Livraison estimée entre le ' + fmt.format(a) + ' et le ' + fmt.format(b);
    } catch (e) { return ''; }
  }
  function paintEta(ctx) {
    $$('[data-q-eta]', ctx).forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min') || '5', 10);
      var max = parseInt(el.getAttribute('data-max') || '8', 10);
      el.textContent = etaText(min, max);
    });
  }
  (function pdpEta() {
    var row = $('.lp-reassure .lp-reassure-row .lp-reassure-txt');
    if (row && !$('.q-eta', row)) {
      var s = document.createElement('span');
      s.className = 'q-eta';
      s.setAttribute('data-q-eta', '');
      row.appendChild(s);
    }
  })();
  paintEta(document);

  /* ---------- Panier coulissant ---------- */
  var drawer = $('[data-q-drawer]');
  var lastFocus = null;

  function setCount(n) {
    $$('.lp-cart-btn').forEach(function (btn) {
      btn.textContent = 'Panier (' + n + ')';
      btn.classList.remove('q-bump'); void btn.offsetWidth; btn.classList.add('q-bump');
    });
  }
  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    root.classList.add('q-lock');
    var close = $('[data-q-close]', drawer);
    if (close) setTimeout(function () { close.focus(); }, 60);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    root.classList.remove('q-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function showError(msg) {
    var err = drawer && $('[data-q-err]', drawer);
    if (!err) return;
    err.textContent = msg;
    err.classList.add('is-on');
  }
  function refreshDrawer() {
    return fetch(ROOT_URL + '?sections=quiet-cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['quiet-cart-drawer'];
        if (!html || !drawer) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-q-drawer-inner]', tmp);
        var current = $('[data-q-drawer-inner]', drawer);
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          paintEta(current);
          var count = fresh.getAttribute('data-count');
          if (count !== null) setCount(count);
        }
      });
  }
  function addToCart(body, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var isForm = body instanceof FormData;
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      headers: isForm ? { 'Accept': 'application/json' } : { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, data: j }; });
    }).then(function (res) {
      return refreshDrawer().then(function () {
        openDrawer();
        if (!res.ok) showError((res.data && (res.data.description || res.data.message)) || "Cet article n'a pas pu être ajouté.");
      });
    }).catch(function () {
      showError("Connexion interrompue, réessayez.");
      openDrawer();
    }).then(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    });
  }
  function changeLine(key, qty, lineEl) {
    if (lineEl) lineEl.classList.add('is-busy');
    return fetch(ROOT_URL + 'cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { showError(j.description || j.message || 'Quantité indisponible.'); });
    }).then(refreshDrawer).catch(function () { refreshDrawer(); });
  }

  if (drawer) {
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);

    /* Ajout au panier depuis n'importe quel formulaire produit du thème */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1 || form.hasAttribute('data-q-no-ajax')) return;
      e.preventDefault();
      var btn = e.submitter || $('[type="submit"]', form);
      addToCart(new FormData(form), btn);
    });

    /* Le bouton « Panier » de l'en-tête ouvre le tiroir */
    document.addEventListener('click', function (e) {
      var cartLink = e.target.closest('.lp-cart-btn');
      if (cartLink && !/\/cart\/?$/.test(location.pathname)) {
        e.preventDefault();
        refreshDrawer();
        openDrawer();
        return;
      }
      if (!drawer.contains(e.target)) return;
      if (e.target.closest('[data-q-close]')) { e.preventDefault(); closeDrawer(); return; }
      var qtyBtn = e.target.closest('[data-q-qty]');
      if (qtyBtn) {
        var line = qtyBtn.closest('[data-key]');
        changeLine(line.getAttribute('data-key'), parseInt(qtyBtn.getAttribute('data-q-qty'), 10), line);
        return;
      }
      var up = e.target.closest('[data-q-add]');
      if (up) {
        addToCart({ items: [{ id: parseInt(up.getAttribute('data-q-add'), 10), quantity: 1 }] }, up);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    paintEta(drawer);
  }

  /* ---------- Quiz « Trouver mon bouchon » ---------- */
  $$('[data-q-quiz]').forEach(function (quiz) {
    var cfgEl = $('[data-q-quiz-config]', quiz);
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var steps = $$('[data-q-step]', quiz);
    var result = $('[data-q-result]', quiz);
    var progress = $$('.q-quiz__progress i', quiz);
    var back = $('[data-q-back]', quiz);
    var history = [];
    var scores = {};

    function go(i) {
      steps.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.hidden = j !== i; });
      result.classList.remove('is-active'); result.hidden = true;
      progress.forEach(function (p, j) { p.classList.toggle('is-done', j < i); });
      back.hidden = history.length === 0;
    }
    /* Sur téléphone, garde la question (ou le résultat) à l'écran après chaque réponse */
    function keepInView() {
      var r = quiz.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.6) {
        quiz.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    }
    function total() {
      var s = {};
      history.forEach(function (h) {
        Object.keys(h.score).forEach(function (k) { s[k] = (s[k] || 0) + h.score[k]; });
      });
      return s;
    }
    function showResult(forced) {
      scores = total();
      var ranked = Object.keys(cfg.products)
        .filter(function (k) { return !cfg.products[k].only_forced; })
        .sort(function (a, b) { return (scores[b] || 0) - (scores[a] || 0); });
      var winner = forced || ranked[0];
      var runner = ranked.filter(function (h) { return h !== winner; })[0];
      var p = cfg.products[winner];
      if (!p) return;
      steps.forEach(function (s) { s.classList.remove('is-active'); s.hidden = true; });
      progress.forEach(function (bar) { bar.classList.add('is-done'); });
      $('[data-r-img]', result).src = p.img;
      $('[data-r-img]', result).alt = p.title;
      $('[data-r-title]', result).textContent = p.title;
      $('[data-r-why]', result).textContent = p.why;
      $('[data-r-facts]', result).innerHTML = p.facts.map(function (f) { return '<li>' + f + '</li>'; }).join('');
      $('[data-r-price]', result).innerHTML = (p.compare > p.price ? '<s>' + money(p.compare) + '</s>' : '') + '<b>' + money(p.price) + '</b>';
      $('[data-r-url]', result).href = p.url;
      var idInput = $('[data-r-variant]', result);
      idInput.value = p.variant;
      var addBtn = $('[data-r-add]', result);
      addBtn.disabled = !p.available;
      addBtn.innerHTML = p.available ? 'Ajouter au panier <span class="q-arrow">→</span>' : 'Épuisé';
      var alt = $('[data-r-alt]', result);
      var rp = runner && cfg.products[runner];
      if (alt && rp && !forced) {
        alt.innerHTML = 'Aussi adapté à votre profil : <a href="' + rp.url + '">' + rp.title + '</a>';
        alt.hidden = false;
      } else if (alt) { alt.hidden = true; }
      result.hidden = false;
      result.classList.add('is-active');
      back.hidden = false;
    }
    quiz.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-q-opt]');
      if (opt) {
        var stepEl = opt.closest('[data-q-step]');
        var stepIdx = steps.indexOf(stepEl);
        $$('[data-q-opt]', stepEl).forEach(function (o) { o.classList.remove('is-picked'); });
        opt.classList.add('is-picked');
        var score = {};
        try { score = JSON.parse(opt.getAttribute('data-score') || '{}'); } catch (err) {}
        history = history.slice(0, stepIdx);
        history.push({ step: stepIdx, score: score });
        var jump = opt.getAttribute('data-result');
        setTimeout(function () {
          if (jump) showResult(jump);
          else if (stepIdx + 1 < steps.length) go(stepIdx + 1);
          else showResult();
          keepInView();
        }, 260);
        return;
      }
      if (e.target.closest('[data-q-back]')) {
        if (result.classList.contains('is-active')) {
          var last = history.length ? history[history.length - 1].step : 0;
          history = history.slice(0, last);
          go(last);
        } else {
          var current = steps.findIndex(function (s) { return s.classList.contains('is-active'); });
          history = history.slice(0, Math.max(0, current - 1));
          go(Math.max(0, current - 1));
        }
        keepInView();
        return;
      }
      if (e.target.closest('[data-q-restart]')) { history = []; go(0); keepInView(); }
    });
    go(0);
  });

  /* ---------- Chiffres qui défilent ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var countIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        countIO.unobserve(el);
        var target = parseFloat(el.getAttribute('data-q-count'));
        var suffix = el.getAttribute('data-suffix') || '';
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / 1200);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    $$('[data-q-count]').forEach(function (el) { countIO.observe(el); });
  }
})();